import { render, staticRenderFns } from "./BaseHeightTransition.vue?vue&type=template&id=433cbff3&scoped=true"
import script from "./BaseHeightTransition.vue?vue&type=script&lang=js"
export * from "./BaseHeightTransition.vue?vue&type=script&lang=js"
import style0 from "./BaseHeightTransition.vue?vue&type=style&index=0&id=433cbff3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "433cbff3",
  null
  
)

export default component.exports